$(function() {

    $('.news-content .youtube-embed').each(function() {

        var iframe = $(this).find('iframe');

        var ratio = (iframe[0].height / iframe[0].width) * 100;
        $(this).find('.youtube-embed__inner').css('padding-top', ratio + '%');

    })

})